// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YXSz2","tab-children":"styles_tab-children__5fet+","tab-children-error":"styles_tab-children-error__JiqRJ"};